const es = {
  site: {
    tagline: 'Coaching de Liderazgo Intencional por Tamara Bonilla',
  },

  nav: {
    links: [
      {label: 'Sobre Mí',    href: '#about'},
      {label: 'Metodología', href: '#methodology'},
      {label: 'Servicios',   href: '#services'},
      {label: 'FAQ',         href: '#faq'},
    ],
    cta: 'Reserva tu Llamada',
  },

  footer: {
    contactLabel:   'Contáctame',
    copyright:      'Todos los derechos reservados.',
    privacyPolicy:  'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
  },

  cookie: {
    messageBefore: 'Usamos cookies para mejorar tu experiencia y entender cómo los visitantes usan nuestro sitio. Lee nuestra',
    policyLink:    'Política de Privacidad',
    messageAfter:  'para más detalles.',
    accept:        'Aceptar',
    decline:       'Rechazar',
    ariaLabel:     'Consentimiento de cookies',
  },

  hero: {
    eyebrow:      'Your Change Mentor',
    headline:     "La mayoría de las formaciones de liderazgo te enseñan a hacer más. Yo te ayudaré a hacer menos de lo que no sirve.",
    subheadline:  "Deja de liderar desde fórmulas que les funcionan a otros pero no a ti. Empieza a liderar con intención y autenticidad — con una metodología que actúa a nivel de identidad, cuerpo y comportamiento simultáneamente.",
    primaryCta:   {label: 'Reserva una Llamada de Descubrimiento', anchor: '#lead-capture'},
    secondaryCta: {label: 'Únete al Newsletter',                     anchor: '#lead-capture'},
    trust:        'Únete a líderes primerizos de 3 continentes que aprenden a liderar de forma intencional',
    cards: [
      {icon: '🧠', title: 'Inmunidad al Cambio', sub: 'Descubre qué te tiene realmente estancado'},
      {icon: '✨', title: 'Diseño Humano',        sub: 'Lidera con intención — no basado en una plantilla o checklist'},
      {icon: '🌬️', title: 'HypnoBreathwork',     sub: 'Implementa cambios duraderos en tu sistema nervioso'},
    ],
  },

  problem: {
    eyebrow: 'La Realidad',
    heading: '¿Te ascendieron? ¿Y ahora qué?',
    sub:     "Trabajaste duro para llegar aquí. Pero nadie te advirtió que las habilidades que te ganaron el ascenso no son las que te harán un gran líder.",
    stats: [
      {value: '82%', label: 'de los líderes NO reciben formación formal antes de asumir su primer equipo',         source: 'Chartered Management Institute'},
      {value: '74%', label: 'de los líderes primerizos luchan por mantener el equilibrio vida-trabajo en su nuevo rol', source: 'CCL Research'},
      {value: '59%', label: 'señalan la adaptación a la autoridad y la gestión de personas como su principal reto', source: 'Center for Creative Leadership'},
    ],
    empathy: "Lo sé porque yo he estado ahí. Me dijeron que fingiera hasta lograrlo. Pero eso me hacía sentir inadecuada, y el síndrome del impostor controlaba todo. No se trata de fingir, se trata de \"fallar hasta aprenderlo\" y ESA es la razón por la que existe este trabajo, para ayudarte a navegar esa transición con valentía",
    beliefs: [
      {belief: '"Necesito tener todas las respuestas para ser un buen líder."', truth: 'Los grandes líderes hacen grandes preguntas. Las respuestas se pueden delegar — el juicio no.'},
      {belief: '"Si muestro vulnerabilidad, no me respetarán."',               truth: 'La claridad y la honestidad SON autoridad. La confianza fingida la erosiona con el tiempo.'},
      {belief: '"No tengo tiempo para descansar o hacer lo que amo."',         truth: 'El descanso no es el enemigo de la productividad. Es la estrategia.'},
      {belief: '"Liderar significa ser perfecto todo el tiempo."',             truth: 'La perfección es una armadura. El liderazgo intencional es el trabajo que hay debajo.'},
    ],
    bridge:         "Hay una forma diferente de liderar.",
    beliefsHeading: 'Las historias que te tienen estancado:',
    seeMethod:      'Ver el Método →',
  },

  about: {
    eyebrow: 'Sobre Tamara',
    name:    'Tamara Bonilla',
    title:   'Catalizadora del Cambio, Entusiasta del Liderazgo, Coach de Diseño Humano, Facilitadora de HypnoBreathwork',
    bio: [
      "Construí mi carrera en el mundo corporativo en el área de cumplimiento regulatorio y me convertí en la persona a la que todos llamaban la high-performer — hasta que choqué contra un muro que no podía superar con más esfuerzo.",
      "Operaba desde el perfeccionismo, la necesidad de probar mi valía y desde la agotadora creencia de que si simplemente trabajaba más duro y no mostraba debilidad, finalmente sentiría que pertenecía a la sala. No era sostenible. Y no era yo.",
      "El giro no fue un momento único. Fue una acumulación de herramientas — el Diseño Humano, que me dio permiso para liderar con autenticidad en lugar de seguir una plantilla. El marco de Inmunidad al Cambio, que reveló los compromisos inconscientes que me mantenían estancada. El HypnoBreathwork, que ayudó a mi sistema nervioso a creer realmente los cambios que mi mente ya había hecho.",
      "Hoy trabajo con líderes primerizos que hacen lo que yo hacía — interpretar el liderazgo en lugar de desarrollarlo. Mi don como Proyectora —mi arquetipo energético en Diseño Humano— es ver el potencial de las personas antes de que ellas mismas puedan verlo. Las ayudo a dejar de fingirlo y a empezar a construirlo.",
    ],
    certifications: [
      'Coach de Diseño Humano',
      'Certificada en HypnoBreathwork',
      'Facilitadora del Mapa de Inmunidad al Cambio',
      'Certificada de Gestión del Cambio metodología Prosci',
    ],
    workWithCta: 'Trabaja con Tamara',
  },

  methodology: {
    eyebrow: 'El Método YCM',
    heading: 'Tres Pasos. Tres Niveles. Una Transformación.',
    sub:     "La mayoría de los programas abordan lo que estás haciendo mal. YCM aborda por qué sigues haciéndolo — y te da herramientas para cambiar en todos los niveles: cognitivo, subconsciente y somático.",
    steps: [
      {
        number:  '01',
        label:   'Inmunidad al Cambio (Harvard ITC)',
        accent:  'teal',
        heading: 'Desenmascarar tu sistema de sabotaje',
        problem: "Sigues intentando las mismas estrategias y te preguntas por qué no puedes avanzar — a pesar de tu mejor esfuerzo.",
        description: 'El marco de Inmunidad al Cambio revela las fuerzas psicológicas ocultas que mantienen estancados incluso a los líderes de alto rendimiento. Sin comprender tu sistema de resistencia interna, sigues saboteando tu propio progreso.',
        learn: [
          "Identifica tu objetivo de mejora auténtico — lo que realmente importa para ti y quienes te rodean",
          "Mapea los comportamientos que estás haciendo (o no haciendo) que contradicen tus compromisos",
          "Descubre los grandes supuestos que impulsan tus comportamientos protectores",
        ],
        milestone: "Completas tu mapa de Inmunidad al Cambio y experimentas el momento 'ajá' — finalmente entiendes por qué el cambio se ha sentido tan difícil, a pesar de desearlo tanto.",
      },
      {
        number:  '02',
        label:   'Diseño Humano',
        accent:  'lavender',
        heading: 'Diseño Auténtico',
        problem: "Te agota seguir consejos de liderazgo que no se alinean con tu energía natural. Te sientes inauténtico y te desgastas tratando de ser alguien que no eres.",
        description: 'El Diseño Humano revela cómo estás diseñado específicamente para tomar decisiones, interactuar con otros y sostener tu energía. Cuando operas según tu diseño, dejas de luchar contigo mismo.',
        learn: [
          "Tu estilo de liderazgo basado en tu tipo de energía y perfil de Diseño Humano",
          "Tu estrategia única de toma de decisiones (Autoridad) — para que las decisiones dejen de sentirse agonizantes",
          "Tus patrones de energía y ritmos de trabajo sostenibles — sin más consejos de talla única",
        ],
        milestone: "Tienes un Informe de Diseño de Liderazgo personalizado y has implementado estrategias alineadas con tu diseño que aumentan notablemente tu energía y efectividad.",
      },
      {
        number:  '03',
        label:   'HypnoBreathwork',
        accent:  'accent',
        heading: 'Integración del Sistema Nervioso',
        problem: "Intelectualmente entiendes lo que necesitas cambiar pero no puedes encarnarlo consistentemente — especialmente bajo estrés. Vuelves a los viejos patrones cuando llega la presión.",
        description: 'El cambio duradero ocurre a nivel del sistema nervioso, no solo a nivel cognitivo. El HypnoBreathwork fusiona la respiración consciente, la hipnosis y la visualización respaldada por la neurociencia para alcanzar el subconsciente en cuestión de minutos, no horas.',
        learn: [
          "La conexión entre el estado de tu sistema nervioso, la inteligencia emocional y la efectividad del liderazgo",
          "HypnoBreathwork — alcanza el estado theta en cuestión de minutos, no horas, a diferencia de la meditación tradicional",
          "Rutinas de regulación previas a reuniones y decisiones que puedes usar de inmediato",
        ],
        milestone: "Puedes cambiar rápidamente el estado de tu sistema nervioso cuando estás estresado, mantener una presencia tranquila durante situaciones difíciles de liderazgo y has establecido prácticas diarias que sostienen el alto rendimiento sin agotamiento.",
      },
    ],
    learnTitle: 'Lo que aprenderás:',
    startCta:   'Comienza tu Transformación',
  },

  servicesSection: {
    label:    '¿Cómo podemos trabajar juntos?',
    heading:  'Elige tu Camino',
    sub:      'Cada compromiso se construye alrededor de tu contexto específico — ya seas un líder individual, un equipo o una organización.',
    whoLabel: 'Para quién:',
  },

  services: [
    {
      id:      '1on1-coaching',
      title:   'Coaching y Mentoría de Liderazgo 1:1',
      who:     'Líderes primerizos navegando la transición de contribuidor individual a líder intencional — en su rol corporativo, no alejándose de él.',
      format:  'Sesiones privadas online, horario flexible',
      outcome: 'Del síndrome del impostor y el agotamiento a un liderazgo seguro y fundamentado — sin quemarte ni convertirte en alguien que no eres.',
      cta:     {label: 'Reserva una Llamada de Descubrimiento', anchor: '#lead-capture'},
      icon:    'coaching',
    },
    {
      id:      'group-coaching',
      title:   'Coaching Grupal y Círculos de HypnoBreathwork',
      who:     'Líderes listos para una transformación con apoyo de pares en un entorno grupal seleccionado.',
      format:  'Programa de cohorte en vivo o círculos grupales continuos (online)',
      outcome: "Construye tu identidad de liderazgo junto a otros que hacen el mismo trabajo — responsabilidad, conexión y el alivio de saber que no estás solo.",
      cta:     {label: 'Únete a la Lista de Espera', href: 'mailto:hello@yourchangementor.com?subject=Group Coaching Waitlist'},
      icon:    'group',
    },
    {
      id:      'corporate-breathwork',
      title:   'Talleres Corporativos',
      who:     'Líderes de RRHH, equipos de L&D y gerentes de equipo que buscan intervenciones experienciales de bienestar.',
      format:  'Sesiones de respiración facilitadas presenciales o virtuales — retiros de equipo, team building, jornadas fuera de la oficina.',
      outcome: "Resetea el estrés del equipo, mejora la claridad en la toma de decisiones, construye seguridad psicológica — en una sola sesión.",
      cta:     {label: 'Solicita una Sesión Corporativa', href: 'mailto:hello@yourchangementor.com?subject=Corporate Session Request'},
      icon:    'corporate',
    },
    {
      id:      'speaking',
      title:   'Eventos',
      who:     'Organizadores de conferencias, cumbres de liderazgo, eventos corporativos, facilitadores de retiros.',
      format:  'Keynote, panel, taller o experiencia completa de respiración.',
      outcome: "Tu audiencia se va con una experiencia transformadora Y herramientas prácticas que puede usar a la mañana siguiente.",
      cta:     {label: 'Invita a Tamara a tu Evento', href: 'mailto:hello@yourchangementor.com?subject=Speaking Inquiry'},
      icon:    'speaking',
    },
  ],

  results: {
    eyebrow: 'Prueba Social',
    heading: 'Una Transformación que Permanece',
    sub:     'Resultados reales de líderes que se comprometieron a liderar diferente.',
    metrics: [
      {value: 200, suffix: '+',    label: 'Líderes Impactados'},
      {value: 3,   suffix: '',     label: 'Continentes Atendidos'},
      {value: 4,   suffix: ' min', label: 'para alcanzar el estado theta con HypnoBreathwork'},
      {value: 95,  suffix: '%',    label: 'reportan cambio conductual duradero en 8 semanas'},
    ],
    testimonials: [
      {
        quote: "Pasé mi primer año como líder completamente agotada, tratando de serlo todo para todos. Trabajando con Tamara, finalmente entendí POR QUÉ seguía saboteándome — y lo más importante, cómo detenerlo. El trabajo de Diseño Humano solo ya valió la pena.",
        name:  'Líder de Ingeniería, Startup Serie B',
      },
      {
        quote: "Pasé de temer las conversaciones difíciles a sentirme realmente lista para ellas. El breathwork me da algo que puedo usar EN EL MOMENTO, no solo en teoría. Esto no es como ningún coaching que haya probado antes.",
        name:  'Gerente Senior, Banco Global',
      },
    ],
  },

  leadMagnet: {
    eyebrow:   'Newsletter Gratuito',
    heading:   'Leadership Lab',
    subtitle:  'Perspectivas Mensuales para Líderes Primerizos',
    sub:       "Perspectivas prácticas de liderazgo, cambios de mentalidad y herramientas reales — entregadas mensualmente en LinkedIn. Escrito para líderes primerizos navegando la transición más difícil de su carrera.",
    bullets: [
      'Perspectivas de Inmunidad al Cambio para el liderazgo cotidiano',
      'Consejos de Diseño Humano para tu estilo de liderazgo',
      'Herramientas de HypnoBreathwork que puedes usar antes de tu próxima reunión',
    ],
    guideLabel:        'Newsletter',
    tabGuide:          'Únete al Newsletter',
    tabBooking:        'Reserva una Llamada',
    newsletterHeading: 'Únete al Leadership Lab en LinkedIn',
    newsletterText:    "Perspectivas mensuales para líderes primerizos — herramientas prácticas, cambios de mentalidad y marcos de liderazgo. Gratis, directo a tu feed de LinkedIn.",
    cta:               'Suscribirse en LinkedIn',
    bookingHeading:    'Reserva una Llamada de Descubrimiento Gratuita de 30 min',
    bookingText:       'Hablemos de dónde estás y a dónde quieres llegar. Sin ventas — solo una conversación real.',
    bookingCta:        'Reserva tu Llamada de Descubrimiento',
  },

  podcast: {
    eyebrow:      'Aparición en Podcast',
    heading:      'Tamara en The Mastry Experience',
    episodeTitle: 'La Trampa del Alto Rendimiento: Productividad, Burnout y Sanación del Sistema Nervioso',
    podcastName:  'The Mastry Experience Podcast',
    description:  "Tamara se une a The Mastry Experience para explorar qué sucede cuando el alto rendimiento se convierte en una trampa — y cómo la sanación del sistema nervioso y una relación redefinida con la productividad desbloquean un liderazgo sostenible.",
    watchCta:     'Ver en YouTube',
    watchUrl:     'https://youtu.be/i-ynRy_0NUQ',
  },

  faqSection: {
    label:              'FAQ',
    heading:            'Preguntas Frecuentes',
    sub:                'Todo lo que necesitas saber antes de decidir si YCM es para ti.',
    stillHaveQuestions: '¿Aún tienes preguntas?',
    emailUs:            'Escríbenos Directamente',
  },

  faq: [
    {
      q: "¿Qué es el Diseño Humano y qué necesito saber?",
      a: "No se necesita conocimiento previo. El Diseño Humano es tu manual de operaciones de liderazgo — un mapa personalizado basado en tus datos de nacimiento que revela cómo funciona tu energía, cómo tomas mejores decisiones y cómo lideras naturalmente. Tamara te guía a través de todo el proceso. Piénsalo como el manual de instrucciones que nunca recibiste.",
    },
    {
      q: "He probado coaching y no me funcionó. ¿Cómo es esto diferente?",
      a: "La mayoría del coaching solo trabaja a nivel de mentalidad. YCM trabaja en tres niveles simultáneamente: identidad (Diseño Humano), subconsciente y cuerpo (HypnoBreathwork) y comportamiento (Inmunidad al Cambio). El cambio se consolida cuando se abordan los tres niveles juntos — por eso la mayoría de los programas independientes no crean resultados duraderos.",
    },
    {
      q: "¿Qué es exactamente el HypnoBreathwork? ¿Es como la meditación?",
      a: "Es más rápido y accesible que la meditación tradicional. El HypnoBreathwork alcanza el estado theta — acceso profundo al subconsciente — en unos 4 minutos, versus 15+ minutos para la meditación tradicional. La naturaleza activa de la respiración le da a tu mente un ancla, así que no hay frustración de 'no puedo dejar de pensar'. Fusiona respiración, hipnosis y visualización en una sola práctica. No se requiere experiencia previa.",
    },
    {
      q: "¿Esto es solo para personas que quieren dejar lo corporativo?",
      a: "Para nada. YCM está diseñado específicamente para líderes que quieren QUEDARSE en sus roles corporativos y liderar mejor — con más facilidad, confianza y sostenibilidad. La transformación ocurre desde adentro mientras permaneces exactamente donde estás. Muchos clientes dicen que el trabajo hace que su carrera corporativa vuelva a sentirse viable.",
    },
    {
      q: "Estoy saturado/a como nuevo/a líder. ¿Cuánto tiempo requiere esto realmente?",
      a: "El coaching está diseñado para profesionales ocupados. Las sesiones son flexibles y online. Las herramientas que aprendes — rutinas de breathwork, prácticas de regulación pre-reunión, decisiones alineadas con tu diseño — se integran en tu agenda existente, no encima de ella. La mayoría de los clientes dedican 60–90 minutos semanales a su trabajo en YCM.",
    },
    {
      q: "¿Trabajas con equipos o solo con individuos?",
      a: "Con ambos. El coaching 1:1 y los programas grupales sirven a líderes individuales; las sesiones corporativas de breathwork y las ponencias sirven a equipos y organizaciones de todos los tamaños. Si eres un líder de RRHH o L&D explorando programas para equipos, contáctame directamente.",
    },
    {
      q: "¿Ofreces sesiones en inglés?",
      a: "Sí. Tamara trabaja con clientes en inglés y español y ofrece sesiones corporativas y contenido de email en ambos idiomas. La secuencia de email de YCM está disponible en inglés a través de Flodesk.",
    },
    {
      q: "¿Qué resultados puedo esperar de manera realista?",
      a: "Los clientes reportan consistentemente mayor claridad en la toma de decisiones, reducción de ansiedad y reactividad, relaciones más sólidas con el equipo y más confianza en conversaciones difíciles — dentro de las primeras semanas. La metodología está diseñada para el cambio duradero, no el alivio temporal. La transformación no se vuelve más fácil. Tú te vuelves mejor eligiendo qué incomodidad te hace avanzar.",
    },
  ],

  whyNow: {
    label:   'Por Qué Ahora',
    heading: 'Por Qué los Líderes Buscan Apoyo Ahora',
    points: [
      {title: 'El ritmo del cambio se acelera',                      body: 'Las organizaciones se reestructuran más rápido que nunca. Los líderes que pueden navegar la ambigüedad tienen una ventaja compuesta.'},
      {title: 'Los puntos de inflexión profesional son más críticos', body: 'El primer rol de liderazgo marca la trayectoria. Los patrones que se forman ahora — buenos o malos — se vuelven autorreinforces.'},
      {title: 'Los marcos trascienden cualquier proyecto individual', body: 'Las herramientas que construyes aquí te acompañan a través de roles, empresas e industrias. Esto es infraestructura para tu carrera.'},
    ],
    visualTitle: 'El costo de no actuar',
    visualItems: [
      'Desenganche del equipo durante el cambio',
      'Estancamiento profesional en una inflexión crítica',
      'Agotamiento por liderar sin un sistema',
      'Perder la ventana para tu próximo movimiento',
    ],
    ctaText:    '¿Listo/a para liderar el cambio en tus propios términos?',
    bookingCta: 'Reserva tu Llamada de Descubrimiento',
  },

  legal: {
    privacy: {
      pageLabel:     'Legal',
      title:         'Política de Privacidad',
      updatedPrefix: 'Última actualización:',
      intro:         'Your Change Mentor ("Your Change Mentor", "nosotros", "nos" o "nuestro") está comprometido con la protección de tu información personal. Esta Política de Privacidad explica qué recopilamos, cómo lo usamos y tus derechos sobre tus datos.',

      s1Heading:   '1. Información que Recopilamos',
      s1Para1:     'Recopilamos información que nos proporcionas directamente, incluyendo:',
      s1Item1Bold: 'Información de contacto:',
      s1Item1Text: 'Nombre, dirección de correo electrónico, nombre de empresa y opcionalmente número de teléfono cuando envías nuestro formulario de captación.',
      s1Item2Bold: 'Comunicaciones:',
      s1Item2Text: 'Mensajes que nos envías por correo electrónico o a través del sitio.',
      s1Item3Bold: 'Información de reserva:',
      s1Item3Text: 'Si reservas una llamada de descubrimiento a través de Calendly, Calendly recopila tu nombre, correo electrónico y preferencias de horario según su propia política de privacidad.',
      s1Para2:     'También podemos recopilar información automáticamente, incluyendo:',
      s1AutoItem:  'Tipo de navegador, sistema operativo, URLs de referencia y páginas visitadas (a través de cookies o herramientas de análisis cuando están habilitadas).',

      s2Heading: '2. Cómo Usamos tu Información',
      s2Para1:   'Usamos la información que recopilamos para:',
      s2Items: [
        'Entregar el recurso gratuito que solicitaste por correo electrónico.',
        'Responder a tus consultas y programar llamadas de descubrimiento.',
        'Enviar comunicaciones relevantes de coaching y mentoría (puedes darte de baja en cualquier momento).',
        'Mejorar nuestro sitio y servicios.',
      ],
      s2Para2: 'No vendemos tu información personal a terceros.',

      s3Heading:   '3. Cómo Compartimos tu Información',
      s3Para1:     'Podemos compartir tu información con:',
      s3Item1Bold: 'Proveedores de servicios de correo electrónico',
      s3Item1Text: '(Mailchimp o SendGrid) para entregar el recurso solicitado y enviar comunicaciones de seguimiento.',
      s3Item2Bold: 'Calendly',
      s3Item2Text: 'para facilitar las reservas de llamadas de descubrimiento.',
      s3Item3Bold: 'Google Sheets / Zapier o Make',
      s3Item3Text: 'para la gestión interna de contactos.',
      s3Item4Bold: 'Cloudflare',
      s3Item4Text: 'para alojamiento del sitio, seguridad y servicios CDN.',
      s3Para2:     'Todos los proveedores terceros están obligados a manejar tus datos de forma segura y de acuerdo con sus propias políticas de privacidad.',

      s4Heading: '4. Cookies',
      s4Para1:   'Usamos cookies para recordar tu preferencia de consentimiento de cookies. Cuando las herramientas de análisis estén habilitadas en una futura actualización, las cookies también pueden usarse para analizar el tráfico del sitio. Puedes controlar las preferencias de cookies a través de la configuración de tu navegador. Nuestro banner de consentimiento de cookies te da la opción de aceptar o rechazar cookies no esenciales.',

      s5Heading: '5. Retención de Datos',
      s5Para1:   'Conservamos tu información personal durante el tiempo necesario para prestar nuestros servicios y cumplir con los fines descritos en esta política. Puedes solicitar la eliminación de tus datos en cualquier momento.',

      s6Heading:    '6. Tus Derechos',
      s6Para1:      'Dependiendo de tu ubicación, puedes tener derecho a:',
      s6Items: [
        'Acceder a los datos personales que tenemos sobre ti.',
        'Solicitar la corrección de datos inexactos.',
        'Solicitar la eliminación de tus datos.',
        'Darte de baja de comunicaciones de marketing en cualquier momento.',
      ],
      s6EmailBefore: 'Para ejercer cualquiera de estos derechos, escríbenos a',
      s6EmailAfter:  'con el asunto "Solicitud de Privacidad". Responderemos en un plazo de 30 días.',

      s7Heading: '7. Seguridad',
      s7Para1:   'Utilizamos medidas de seguridad estándar de la industria para proteger tu información personal. Sin embargo, ningún método de transmisión por internet es 100% seguro. No podemos garantizar seguridad absoluta.',

      s8Heading: '8. Privacidad de Menores',
      s8Para1:   'Nuestros servicios no están dirigidos a personas menores de 16 años. No recopilamos conscientemente información personal de niños.',

      s9Heading: '9. Cambios en Esta Política',
      s9Para1:   'Podemos actualizar esta Política de Privacidad de vez en cuando. Te notificaremos los cambios significativos actualizando la fecha en la parte superior de esta página. El uso continuado del sitio después de los cambios constituye tu aceptación de la política actualizada.',

      s10Heading: '10. Contáctanos',
      s10Para1:   'Si tienes preguntas sobre esta Política de Privacidad o cómo manejamos tus datos, contáctanos en:',
    },

    terms: {
      pageLabel:     'Legal',
      title:         'Términos de Servicio',
      updatedPrefix: 'Última actualización:',
      intro:         'Por favor lee estos Términos de Servicio ("Términos") cuidadosamente antes de usar el sitio web yourchangementor.com (el "Sitio") operado por Your Change Mentor ("nosotros", "nos" o "nuestro"). Al acceder o usar el Sitio, aceptas estar sujeto a estos Términos.',

      s1Heading: '1. Uso del Sitio',
      s1Para1:   'Solo puedes usar el Sitio para propósitos lícitos. Aceptas no usar el Sitio de ninguna manera que:',
      s1Items: [
        'Viole cualquier ley o regulación local, nacional o internacional aplicable.',
        'Sea dañina, fraudulenta, engañosa o misleading.',
        'Infrinja los derechos de terceros.',
        'Intente obtener acceso no autorizado a cualquier parte del Sitio o su infraestructura.',
      ],

      s2Heading: '2. Propiedad Intelectual',
      s2Para1:   'Todo el contenido de este Sitio — incluyendo texto, gráficos, logotipos, recursos descargables y el diseño general — es propiedad de Your Change Mentor y está protegido por las leyes de propiedad intelectual aplicables. No puedes reproducir, distribuir o crear obras derivadas sin nuestro permiso expreso por escrito.',
      s2Para2:   'Los recursos gratuitos (Autoevaluación de Preparación para el Cambio y Guía de Hoja de Ruta para la Transición Profesional) se proporcionan solo para tu uso personal y no comercial.',

      s3Heading: '3. Servicios de Coaching y Mentoría',
      s3Para1:   'Cualquier servicio de coaching o mentoría descrito en este Sitio está sujeto a un acuerdo de servicio separado. El contenido de este Sitio es solo para fines informativos y no constituye asesoramiento profesional.',
      s3Para2:   'Los resultados descritos o implícitos en este Sitio representan resultados obtenidos por individuos específicos y no están garantizados. Los resultados individuales variarán.',

      s4Heading: '4. Exclusión de Garantías',
      s4Para1:   'El Sitio y su contenido se proporcionan "tal cual" sin garantías de ningún tipo, ya sean expresas o implícitas, incluyendo pero no limitado a garantías implícitas de comerciabilidad, idoneidad para un propósito particular o no infracción.',

      s5Heading: '5. Limitación de Responsabilidad',
      s5Para1:   'En la máxima medida permitida por la ley, Your Change Mentor no será responsable de ningún daño indirecto, incidental, especial, consecuente o punitivo que surja del uso — o la imposibilidad de uso — de este Sitio o su contenido.',

      s6Heading: '6. Enlaces y Servicios de Terceros',
      s6Para1:   'Este Sitio puede contener enlaces a sitios web de terceros o integrar servicios de terceros (como Calendly para reservas). No somos responsables del contenido, las prácticas de privacidad o los términos de esos terceros. Úsalos bajo tu propio criterio.',

      s7Heading: '7. Ley Aplicable',
      s7Para1:   'Estos Términos se rigen e interpretan de acuerdo con la ley aplicable. Cualquier disputa que surja de estos Términos se resolverá en la jurisdicción donde opera Your Change Mentor.',

      s8Heading: '8. Cambios en Estos Términos',
      s8Para1:   'Nos reservamos el derecho de actualizar estos Términos en cualquier momento. Indicaremos la fecha de la actualización más reciente en la parte superior de esta página. El uso continuado del Sitio después de que se publiquen los cambios constituye la aceptación de los Términos revisados.',

      s9Heading: '9. Contáctanos',
      s9Para1:   'Si tienes preguntas sobre estos Términos, contáctanos en:',
    },
  },
};

export default es;
